import { render } from "./LoadScreen.vue?vue&type=template&id=b7bc5f46&scoped=true"
import script from "./LoadScreen.vue?vue&type=script&lang=js"
export * from "./LoadScreen.vue?vue&type=script&lang=js"

import "./LoadScreen.vue?vue&type=style&index=0&id=b7bc5f46&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bc5f46"]])

export default __exports__